// extracted by mini-css-extract-plugin
export default {"icon":"ToolBarIconButton_icon__XfhEf","toolbar-icon-button":"ToolBarIconButton_toolbar-icon-button__YLIb2","toolbarIconButton":"ToolBarIconButton_toolbar-icon-button__YLIb2"};